import { getLookupList, sortLookupOptionsByLabel } from "../utils/apiUtils"
import { ENTITY_NAME_COMPANY, ENTITY_NAME_COMPANY_TYPE, 
  ENTITY_NAME_COMPANY_SUB_TYPE } from "./dbConstants";

export const getListOptions = async() => {
  console.log("CompanyDAO.getListOptions");
  return sortLookupOptionsByLabel(await getLookupList(ENTITY_NAME_COMPANY))
}

export const getTypeListOptions = async() => {
  console.log("CompanyDAO.getTypeListOptions");
  return getLookupList(ENTITY_NAME_COMPANY_TYPE)
}

export const getSubTypeListOptions = async(input) => {
  console.log("CompanyDAO.getSubTypeListOptions");
  const companyTypeId = input?.companyTypeId;
  if(!companyTypeId) {
    return []
  }
  return getLookupList(ENTITY_NAME_COMPANY_SUB_TYPE, {companyTypeId})
}
